import {cn} from '@features/ui/utils';

interface CheckboxProps {
  checked: boolean | 'indeterminate';
  onChange?: () => void;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({
  checked,
  onChange,
  disabled = false,
  className,
}: CheckboxProps) {
  const filled = checked === true || checked === 'indeterminate';
  return (
    <div
      className={cn(
        'flex h-5 w-5 shrink-0 items-center justify-center rounded-md',
        disabled
          ? 'cursor-not-allowed bg-muted'
          : cn(
              onChange && 'cursor-pointer',
              filled ? 'bg-primary' : 'border border-black/15 bg-transparent',
            ),
        className,
      )}
      onClick={() => {
        if (!disabled) {
          onChange?.();
        }
      }}
    >
      {checked === true && !disabled && (
        <svg
          width='14'
          height='14'
          viewBox='0 0 12 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10 3L4.5 8.5L2 6'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )}
      {checked === 'indeterminate' && !disabled && (
        <div className='h-0.5 w-2.5 rounded-full bg-white' />
      )}
    </div>
  );
}
